import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { PreCheckinFormCustomization } from '@precheckin/models/precheckin-form-customization/precheckin-form-customization.model';
import { TrainingCenter } from '@precheckin/models/training-center/training-center.model';
import { PreCheckinFormCustomizationService } from '@precheckin/services/precheckin-form-customization.service';
import { Observable, take } from 'rxjs';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import { GetCheckinFormFields } from './precheckin-form-customization.actions';
import { defaultPreCheckinFormState, IPreCheckinFormCustomizationStateModel } from './precheckin-form-customization.model';
import { PreCheckinTrainingState } from '../training/precheckin-training.state';

@State<IPreCheckinFormCustomizationStateModel>({
  name: AppStoreKeys.PreCheckinFormCustomization,
  defaults: defaultPreCheckinFormState
})
@Injectable()
export class PreCheckinFormCustomizationState {
  trainingCenter$: Observable<TrainingCenter>;
  preCheckinFormCustomization$: Observable<PreCheckinFormCustomization>

  constructor(
    private _preCheckinFormCustomizationService: PreCheckinFormCustomizationService,
    private _store: Store,
    private _router: Router){
    this.trainingCenter$ = _store.select(
      PreCheckinTrainingState.getTrainingCenter
    );

    this.preCheckinFormCustomization$ = _store.select(PreCheckinFormCustomizationState.getCheckinFormFields);
  }

  @Selector()
  public static isFormCustomizationReady(state: IPreCheckinFormCustomizationStateModel): boolean {
    return state.isFormCustomizationReady;
  }

  @Selector()
  public static getCheckinFormFields(state: IPreCheckinFormCustomizationStateModel): PreCheckinFormCustomization {
    return state.preCheckinFormCustomization;
  }

  @Action(GetCheckinFormFields)
  getCheckinFormFieldsByTrainingCenterId(
    ctx: StateContext<IPreCheckinFormCustomizationStateModel>,
    { trainingCenterId }: GetCheckinFormFields
  ): void {
    ctx.patchState({
      isFormCustomizationReady: false
    });

    this._preCheckinFormCustomizationService
      .getCheckinFormFieldsByTrainingCenterId(trainingCenterId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          ctx.patchState({
            preCheckinFormCustomization: new PreCheckinFormCustomization(response),
            isFormCustomizationReady: true
          });
        },
        error: () => {
          ctx.patchState({
            preCheckinFormCustomization: new PreCheckinFormCustomization(),
            isFormCustomizationReady: true
          });
        }
      });
  }
}